export { default } from './DocumentsRouter'
export { default as Documents } from './Documents'
export { default as DocumentDetail } from './DocumentDetail'
export { default as DocumentsRouter } from './DocumentsRouter'
